import { FontIcon, Stack } from '@fluentui/react';
import { FC } from 'react';
import styled from 'styled-components';
import { ListDiv, NoOverflowText } from '../../shared/styled-components';
import { IHandledWorkItem } from '../../models/reports.internal';
import { nameof } from '../../utils/stringUtils';
import ElapsedTimeSpan from './ElapsedTimeSpan';
import { getIsMonitorable, getWorkItemDetails } from './AgentCard.helpers';

//#region [1] WorkItemDisplay
const StyledStack = styled(Stack)`
  border-radius: 0.5rem;
  padding: 0.25rem;

  :hover {
    background-color: ${p => p.theme.palette.neutralLight};
  }
`;

const DetailsContainer = styled.div`
  min-width: 1px;
  flex-grow: 1;
`;

const Bold = styled.span`
  font-weight: 500;
`;

interface IProps {
  workItem: IHandledWorkItem;
  showMonitoring: boolean;
}

const WorkItemDisplay: FC<IProps> = ({ workItem: { channelType, createdAtTimestamp, customerName, primaryConversationId, state, virtualConversationType }, showMonitoring }) => {

  const details = getWorkItemDetails(channelType, virtualConversationType);
  
  return (
    <StyledStack horizontal verticalAlign="center" tokens={{ childrenGap: '0.625rem' }}>
      <FontIcon iconName={details.icon} style={{ fontSize: 28, paddingLeft: '0.25rem' }} />
      <DetailsContainer>
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center" tokens={{ childrenGap: '0.25rem' }}>
          <NoOverflowText tooltip={details.text + (customerName ? ` with ${customerName}` : '')}>
            <Bold>{details.text}</Bold>
            {customerName ? <> with <Bold>{customerName}</Bold></> : null}
          </NoOverflowText>
          <ElapsedTimeSpan startTimestamp={createdAtTimestamp} />
        </Stack>
        <span>{state}</span>
      </DetailsContainer>
    </StyledStack>
  );
};
//#endregion

const ListContainer = styled(ListDiv)`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const WorkItemList: FC<{ workItems: IHandledWorkItem[] }> = ({ workItems }) => {
  const showMonitoring = workItems.some(wi => getIsMonitorable(wi.channelType));

  return (
    <ListContainer>
      {workItems.map((wi, i) => <WorkItemDisplay key={i} workItem={wi} showMonitoring={showMonitoring} />)}
    </ListContainer>
  );
};

WorkItemList.displayName = nameof({ WorkItemList });
export default WorkItemList;